export const DEFAULT_ACCOUNT_SETTING: Readonly<Record<'id' | 'text', string>> = Object.freeze({
    id: '',
    text: 'All accounts',
});
